import Vue from "vue";

export default {
  namespaced: true,
  state: {
    applications: null,
    application_operator: null,
    application_admin: null,
    application_admin_loading: false,
    application_check: null,
    protectors: null,
    protectors_list:null,
    protectors_check:null,
  },
  getters: {
    applications: (state) => state.applications,
    application_operator: (state) => state.application_operator,
    application_admin: (state) => state.application_admin,
    application_admin_loading: (state) => state.application_admin_loading,
    application_check: (state) => state.application_check,
    protectors: (state) => state.protectors,
    protectors_list: (state) => state.protectors_list,
    protectors_check: (state) => state.protectors_check,
  },
  mutations: {
    SET_APPLICATIONS(state, payload) {
      state.applications = payload
    },
    SET_APPLICATIONS_OPERATOR(state, payload) {
      state.application_operator = payload
    },
    SET_APPLICATIONS_ADMIN(state, payload) {
      state.application_admin = payload
    },
    SET_APPLICATIONS_CHECK(state, payload) {
      state.application_check = payload
    },
    SET_PROTECTORS(state, payload){
      state.protectors= payload
    },
    SET_APPLICATIONS_PROTECTORS(state,payload){
      state.protectors_list=payload
    },
    SET_PROTECTORS_CHECK(state, payload){
      state.protectors_check= payload
    },

    BEGIN_APPLICATIONS_ADMIN_LOADING(state) {
      state.application_admin_loading = true
    },
    END_APPLICATIONS_ADMIN_LOADING(state) {
      state.application_admin_loading = false
    },
  },
  actions: {
    async loadApplications({commit}) {
      await Vue.axios.get('operator/list')
        .then((response) => {
          commit('SET_APPLICATIONS', response.data)
        }).catch((err) => {
          console.log(err);
        });
    },

    async loadApplicationsAdmin({commit}) {
      commit("BEGIN_APPLICATIONS_ADMIN_LOADING")
      await Vue.axios.get('operator/admin')
        .then((response) => {
          commit('SET_APPLICATIONS_ADMIN', response.data)
          commit("END_APPLICATIONS_ADMIN_LOADING")
        }).catch((err) => {
          console.log(err);
        });
    },

    async loadApplicationsOperator({commit}) {
      await Vue.axios.get('operator/')
        .then((response) => {
          commit('SET_APPLICATIONS_OPERATOR', response.data)
        })
    },

     async loadApplicationsCheck({commit}, payload) {
      await Vue.axios.get('operator/check/'+payload.id)
        .then((response) => {
          commit('SET_APPLICATIONS_CHECK', response.data)
        })
    },

    async loadProtector({commit}) {
      await Vue.axios.get('operator/protector')
        .then((response) => {
          commit('SET_PROTECTORS', response.data)
        })
    },

    async loadApplicationsProtector({commit}) {
      await Vue.axios.get('operator/list_protector')
        .then((response) => {
          commit('SET_APPLICATIONS_PROTECTORS', response.data)
        })
    },

    async loadProtectorCheck({commit}, payload) {
      await Vue.axios.get('operator/protector_check/', {params: payload})
        .then((response) => {
          commit('SET_PROTECTORS_CHECK', response.data)
        }).catch(() => {
          commit('SET_PROTECTORS_CHECK', {protector:0});
        });
    },
  },
}
